import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { PinComponent } from '../../../common/pin/pin.component';

import {
  MainBannerInitModel,
  MainBannerInitVariables,
  MainBannerModel,
  MainBannerVariables,
} from '../../../../../models/email-template/main-banner.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-main-banner',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './main-banner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './main-banner.component.scss'
})
export class MainBannerComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: MainBannerModel = new MainBannerInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MainBannerInitVariables()
    }
  }

  //@ placeholders
  imageDesktopPlaceholder: string = 'Desktop Image';
  imageMobilePlaceholder: string = 'Mobile Image';
  hrefPlaceholder: string = 'Enter Image Redirect Link';
  altPlaceholder: string = 'Enter Image Alt Text';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof MainBannerVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof MainBannerVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
